import { c as _c } from "react/compiler-runtime";
import { Icon, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import type { StandardTileProps } from '../types';
import './StandardTiles.scss';
export default function StandardTile(linkAction) {
  const $ = _c(14);
  let t0;
  if ($[0] !== linkAction.link) {
    t0 = "iconName" in linkAction.link && {
      iconName: linkAction.link.iconName
    };
    $[0] = linkAction.link;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== linkAction.actionText || $[3] !== linkAction.link.webUrl || $[4] !== t0) {
    t1 = {
      actionText: linkAction.actionText,
      webUrl: linkAction.link.webUrl,
      ...t0
    };
    $[2] = linkAction.actionText;
    $[3] = linkAction.link.webUrl;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const flatLink = t1;
  const t2 = flatLink?.webUrl;
  const t3 = flatLink?.iconName;
  let t4;
  if ($[6] !== t3) {
    t4 = <Icon size="md" name={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== flatLink.actionText) {
    t5 = <TextPassage>{flatLink.actionText}</TextPassage>;
    $[8] = flatLink.actionText;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t5) {
    t6 = <Link href={t2} className="tiles-4--standard" data-testid="tile-standard" prefetch={false}>{t4}{t5}</Link>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}